export interface CreateInterLibraryLoanRecordRequest {
  lendIds: number[]
}

export function CreateInterLibraryLoanRecordRequestToJSON(
  value: CreateInterLibraryLoanRecordRequest
): any {
  return {
    lend_ids: value.lendIds.length > 0 ? value.lendIds : undefined
  }
}
